document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fabric-swatch-picker]').forEach(function (root) {
    var browse = root.querySelector('[data-fabric-browse]');
    var toggleHead = root.querySelector('[data-fabric-toggle-head]');
    var toggleBody = root.querySelector('[data-fabric-toggle-body]');
    var search = root.querySelector('[data-fabric-search]');
    var input = root.querySelector('[data-fabric-choice-input]');
    var note = root.querySelector('[data-fabric-note]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-fabric-swatch]'));
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-fabric-cat]'));
    var tooltip = root.querySelector('[data-fabric-tooltip]');
    var currentThumb = root.querySelector('[data-fabric-current-thumb]');
    var currentName = root.querySelector('[data-fabric-current-name]');
    var reset = root.querySelector('[data-fabric-reset]');
    var error = root.querySelector('[data-fabric-error]');

    // Remember the "as shown" state so Reset can put it back.
    var shown = {
      value: input ? input.value : '',
      nameHtml: currentName ? currentName.innerHTML : '',
      thumbSrc: currentThumb ? currentThumb.getAttribute('src') : null
    };

    function setThumb(src) {
      if (!currentThumb) return;
      if (src) {
        currentThumb.src = src;
        currentThumb.hidden = false;
      } else {
        currentThumb.removeAttribute('src');
        currentThumb.hidden = true;
      }
    }

    function clearSelection() {
      swatches.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
    }

    function showTooltip(button) {
      if (!tooltip) return;
      var name = button.getAttribute('data-fabric-name') || '';
      if (!name) return;
      tooltip.textContent = name;
      tooltip.hidden = false;

      var rect = button.getBoundingClientRect();
      var margin = 8;
      var tooltipRect = tooltip.getBoundingClientRect();
      var desiredCenter = rect.left + rect.width / 2;
      var minCenter = margin + tooltipRect.width / 2;
      var maxCenter = window.innerWidth - margin - tooltipRect.width / 2;
      var center = Math.max(minCenter, Math.min(maxCenter, desiredCenter));

      tooltip.style.left = (center - tooltipRect.width / 2) + 'px';
      tooltip.style.top = (rect.bottom + margin) + 'px';
      tooltip.style.setProperty('--tooltip-arrow-left', (desiredCenter - (center - tooltipRect.width / 2)) + 'px');
    }

    function hideTooltip() {
      if (!tooltip) return;
      tooltip.hidden = true;
    }

    if (toggleHead && toggleBody && browse) {
      // Expand/collapse with a soft height + fade (skipped for prefers-reduced-motion).
      var bodyAnimation = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      // Gentle ease-in, long soft ease-out: reads as a glide rather than a snap.
      var EASING = 'cubic-bezier(0.3, 0, 0.2, 1)';

      // Warm up the swatch thumbnails before the first open, so they aren't downloading/decoding mid-animation.
      var swatchesWarmed = false;
      function warmSwatches() {
        if (swatchesWarmed) return;
        swatchesWarmed = true;
        toggleBody.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
          img.decoding = 'async';
        });
      }
      toggleHead.addEventListener('pointerenter', warmSwatches, { once: true });
      toggleHead.addEventListener('focus', warmSwatches, { once: true });
      if ('requestIdleCallback' in window) {
        window.addEventListener('load', function () {
          window.requestIdleCallback(warmSwatches, { timeout: 4000 });
        });
      }

      function finishClose() {
        browse.classList.remove('is-closing');
        toggleBody.hidden = true;
        toggleBody.style.overflow = '';
        bodyAnimation = null;
      }

      toggleHead.addEventListener('click', function () {
        warmSwatches();
        var isOpen = browse.classList.toggle('is-open');
        toggleHead.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        var startHeight = toggleBody.hidden ? 0 : toggleBody.getBoundingClientRect().height;
        if (bodyAnimation) {
          bodyAnimation.onfinish = null;
          bodyAnimation.cancel();
          bodyAnimation = null;
        }

        if (reduceMotion.matches || typeof toggleBody.animate !== 'function') {
          browse.classList.remove('is-closing');
          toggleBody.hidden = !isOpen;
          return;
        }

        toggleBody.style.overflow = 'hidden';

        if (isOpen) {
          browse.classList.remove('is-closing');
          toggleBody.hidden = false;
          var fullHeight = toggleBody.getBoundingClientRect().height;
          var padding = getComputedStyle(toggleBody);
          // Animate the padding too: otherwise the first/last ~33px are held up by padding + border and the motion stalls.
          var from = startHeight
            ? { height: startHeight + 'px', opacity: 1 }
            : { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px', opacity: 0 };
          bodyAnimation = toggleBody.animate(
            [
              from,
              { opacity: 1, offset: 0.6 },
              {
                height: fullHeight + 'px',
                paddingTop: padding.paddingTop,
                paddingBottom: padding.paddingBottom,
                borderBottomWidth: padding.borderBottomWidth,
                opacity: 1
              }
            ],
            { duration: 480, easing: EASING }
          );
          bodyAnimation.onfinish = function () {
            toggleBody.style.overflow = '';
            bodyAnimation = null;
          };
        } else {
          // Keep the divider under the body (is-closing) until it has folded away.
          browse.classList.add('is-closing');
          var closingStyle = getComputedStyle(toggleBody);
          bodyAnimation = toggleBody.animate(
            [
              {
                height: startHeight + 'px',
                paddingTop: closingStyle.paddingTop,
                paddingBottom: closingStyle.paddingBottom,
                borderBottomWidth: closingStyle.borderBottomWidth,
                opacity: 1
              },
              { opacity: 0, offset: 0.7 },
              { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px', opacity: 0 }
            ],
            { duration: 360, easing: EASING }
          );
          bodyAnimation.onfinish = finishClose;
        }
      });
    }

    swatches.forEach(function (button) {
      button.addEventListener('mouseenter', function () { showTooltip(button); });
      button.addEventListener('mouseleave', hideTooltip);
      button.addEventListener('focus', function () { showTooltip(button); });
      button.addEventListener('blur', hideTooltip);

      button.addEventListener('click', function () {
        clearSelection();
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');

        var name = button.getAttribute('data-fabric-name') || '';
        var nameZh = button.getAttribute('data-fabric-name-zh') || '';

        if (input) {
          input.value = nameZh ? name + ' (' + nameZh + ')' : name;
        }

        if (note) {
          note.innerHTML = note.getAttribute('data-template')
            .replace('__FABRIC_NAME__', name)
            .replace('__FABRIC_NAME_ZH__', nameZh);
          note.hidden = false;
        }

        if (currentName) {
          currentName.textContent = name + ' ';
          var label = document.createElement('small');
          label.textContent = '(selected)';
          currentName.appendChild(label);
        }
        var img = button.querySelector('img');
        setThumb(img ? img.currentSrc || img.src : null);
        if (reset) reset.hidden = false;
        if (error) error.hidden = true;
        if (browse) browse.classList.remove('is-invalid');
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        clearSelection();
        if (input) input.value = shown.value;
        if (currentName) currentName.innerHTML = shown.nameHtml;
        setThumb(shown.thumbSrc);
        if (note) note.hidden = true;
        reset.hidden = true;
      });
    }

    // Sold-out silk: the fabric starts empty and Add to Cart is held until a swatch is picked.
    // Capture on document so this runs before product-form's own submit handler.
    if (input && input.hasAttribute('data-fabric-required')) {
      document.addEventListener('submit', function (evt) {
        if (input.form !== evt.target || input.value) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (error) error.hidden = false;
        if (browse) browse.classList.add('is-invalid');
        if (toggleHead && browse && !browse.classList.contains('is-open')) toggleHead.click();
        // The product info renders twice (desktop + mobile); only scroll to the copy that's visible.
        if (root.offsetParent !== null) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, true);
    }

    if (search) {
      search.addEventListener('input', function () {
        var query = search.value.trim().toLowerCase();
        swatches.forEach(function (button) {
          var name = (button.getAttribute('data-fabric-name') || '').toLowerCase();
          var nameZh = button.getAttribute('data-fabric-name-zh') || '';
          var match = !query || name.indexOf(query) !== -1 || nameZh.indexOf(query) !== -1;
          button.hidden = !match;
        });
        categories.forEach(function (cat) {
          var anyVisible = Array.prototype.slice.call(cat.querySelectorAll('[data-fabric-swatch]')).some(function (b) {
            return !b.hidden;
          });
          cat.hidden = !anyVisible;
        });
      });
    }
  });
});
